exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-capabilities--1HuGJNlbnIhmDFdpQfF6Ju {\n  border-radius: 4px;\n  border: 1px solid #ffae00;\n  background: rgba(255, 174, 0, .3);\n  padding: 1rem;\n  color: #000;\n  margin-bottom: 1rem;\n  line-height: 20px;\n}\n\n.video-capabilities--1vB3T5uz0EyamG5azQMDPn {\n  white-space: pre-line;\n}\n\n.video-capabilities--1vB3T5uz0EyamG5azQMDPn ul {\n  list-style: disc;\n  margin-left: 1.5rem;\n  margin-bottom: .5rem;\n}\n\n.video-capabilities--NJCltS5_xBtmndu9bH18U {\n  margin-top: .5rem;\n}\n", ""]);

// exports
exports.locals = {
	"videoCapabilitiesMessage": "video-capabilities--1HuGJNlbnIhmDFdpQfF6Ju",
	"videoCapabilitiesMessage": "video-capabilities--1HuGJNlbnIhmDFdpQfF6Ju",
	"videoCapabilitiesMessageValue": "video-capabilities--1vB3T5uz0EyamG5azQMDPn",
	"videoCapabilitiesMessageValue": "video-capabilities--1vB3T5uz0EyamG5azQMDPn",
	"videoCapabilitiesLink": "video-capabilities--NJCltS5_xBtmndu9bH18U",
	"videoCapabilitiesLink": "video-capabilities--NJCltS5_xBtmndu9bH18U"
};